import { i18nFilter } from "app/filters/i18nFilter";
import { abbrNumberVisitsFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import { ChipDownContainer, EllipsisDropdownItem } from "@similarweb/ui-components";
import type { IFilterItem } from "app/pages/website-analysis/traffic-sources/display-ads/publishers/common/types";

interface INetworksFilter {
    onNetworksFilterChange(selectedNetworks: any): void;
    networks: IFilterItem[];
    selectedNetwork: string;
}

const i18n = i18nFilter();

export const NetworksFilter: FC<INetworksFilter> = (props) => {
    const { selectedNetwork, networks, onNetworksFilterChange } = props;

    const getNetworks = () =>
        networks.map((network: IFilterItem, index: number) => (
            <EllipsisDropdownItem
                key={index}
                // @ts-expect-error Type number is not assignable to type string
                id={index}
                infoText={abbrNumberVisitsFilter()(network?.Count || 0)}
                disabled={network?.Count == 0}
            >
                {network.Name}
            </EllipsisDropdownItem>
        ));

    return (
        <ChipDownContainer
            width={350}
            tooltipDisabled={true}
            hasSearch={true}
            selectedIds={selectedNetwork && { [selectedNetwork]: true }}
            selectedText={selectedNetwork}
            buttonText={i18n("traffic.sources.display.ads.publishers.networks.filter.chipdown.text")}
            onClick={onNetworksFilterChange}
            onCloseItem={() => onNetworksFilterChange(null)}
            searchPlaceHolder={i18n("traffic.sources.display.ads.publishers.networks.filter.chipdown.placeholder")}
            noResultsMessage={i18n("dropdown.no.results")}
            disabled={!networks || networks.length === 0}
        >
            {getNetworks()}
        </ChipDownContainer>
    );
};
